import React from 'react';

import { Typography } from 'antd-v5';
import type { ParagraphProps as AntParagraphProps } from 'antd-v5/es/typography/Paragraph';
import type { TextProps as AntTextProps } from 'antd-v5/es/typography/Text';
import cn from 'classnames';
import fonts from 'scouting-ui/lib/scss/_fonts.scss';
import type { ColorType } from 'scouting-ui/lib/types';

import styles from './Text.scss';

export const Link = Typography.Link;

type FontVariants =
  | 'body-body-1'
  | 'body-body-2'
  | 'body-body-3'
  | 'body-body-4'
  | 'body-caption'
  | 'body-caption'
  | 'body-overline'
  | 'buttons-large'
  | 'buttons-medium'
  | 'buttons-small';

interface ParagraphProps extends AntParagraphProps {
  font?: FontVariants;
  color?: ColorType;
}

export const Paragraph: React.FC<ParagraphProps> = props => {
  const {
    font = 'body-body-3',
    color,
    style,
    className,
    ...otherProps
  } = props;
  const fontClass = fonts ? fonts[`text-${font}`] : undefined;
  const colorProp = color ? `var(--${color})` : undefined;
  return (
    <Typography.Paragraph
      style={{ color: colorProp, ...style }}
      className={cn(fontClass, className, {
        [styles.cursorPointer]: !!otherProps.onClick,
      })}
      {...otherProps}
    />
  );
};

export interface TextProps extends AntTextProps {
  font?: FontVariants;
  color?: ColorType;
  /** If true, uses Paragraph, otherwise inline. Default: `false` */
  paragraph?: boolean;
  /** If true, doesn't use paragraph as tag. Default: `true` */
  inline?: boolean;
}

export const Text: React.FC<TextProps> = props => {
  const {
    font = 'body-body-3',
    paragraph = false,
    inline = true,
    color,
    className,
    style = {},
    ...otherProps
  } = props;
  const fontClass = fonts ? fonts[`text-${font}`] : undefined;
  const colorProp = color ? `var(--${color})` : undefined;

  if (paragraph || !inline)
    return <Paragraph {...{ font, color, className }} {...otherProps} />;

  return (
    <Typography.Text
      style={{ color: colorProp, ...style }}
      className={cn(fontClass, className, {
        [styles.cursorPointer]: !!otherProps.onClick,
      })}
      {...otherProps}
    />
  );
};

export default Text;
